// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Bo-z","slideIn":"Co-z"};